import { ParamsData, PARAM_SORT } from '../constants'

/**
 * sort, filter 기능을 사용하기 위한 함수
 * @param store 상태 관리할 스토어
 * @param sortType sort 타입
 * @param filterType filter 타입
 * @param filterName filter key 값
 * @param categoryIds category id
 * @param status status 값
 * @example
 * onParams({
 *  store: marketStore
 *  sortType: sortType
 *  filterType: filterType
 *  filterName: 'type'
 *  categoryIds: 1
 * })
 */
export const onParams = async (paramsData: ParamsData) => {
  const newSort = paramsData.sortType
    ? (PARAM_SORT[paramsData.sortType as keyof typeof PARAM_SORT] as unknown as string[])
    : undefined
  const filterKey = paramsData.filterName as string
  if (paramsData.categoryIds === 0) paramsData.categoryIds = undefined

  try {
    await paramsData.store.load(
      {
        data: {
          // TODO: 수정 필요
          categoryId: paramsData.categoryId,
          categoryIds: paramsData.categoryIds,
          sort: newSort,
          status: paramsData.status,
          ...(filterKey ? { [filterKey]: paramsData.filterType } : undefined),
        },
      },
      true,
    )
  } catch (err: unknown) {
    console.error(err)
  }
}
